import React from 'react';
import ReactDOM from 'react-dom';
import { match } from 'react-router';
import { load as loadHypernova } from 'hypernova';

import createRoutes from '../routes';
import UrlGenerator from '../lib/UrlGenerator';

const createHypernovaRenderer = (Components) => {
    const findComponent = name => Components[name] || null;

    const renderReact = (el, componentName, props) => {
        const Component = findComponent(componentName);
        if (Component === null) {
            console.warn(`Component ${componentName} not found.`);
            return;
        }
        ReactDOM.render(React.createElement(Component, props), el);
    };

    const createRenderReact = (...args) => () => renderReact(...args);

    const renderHypernovaElements = (elements) => {
        elements.forEach((el) => {
            const componentName = el.dataset ? el.dataset.hypernovaKey : el.getAttribute('data-hypernova-key');
            const nodes = loadHypernova(componentName);
            nodes.forEach(({ node, data }) => {
                const urlGenerator = new UrlGenerator(data.routes || null);
                const routes = createRoutes(urlGenerator);
                const props = {
                    routerRoutes: routes,
                    urlGenerator,
                    ...data,
                };
                if (typeof props.url !== 'undefined') {
                    match({
                        routes,
                        location: data.url,
                    }, createRenderReact(node, componentName, props));
                } else {
                    renderReact(node, componentName, props);
                }
            });
        });
    };

    return renderHypernovaElements;
};

export default createHypernovaRenderer;



// WEBPACK FOOTER //
// ./utils/createHypernovaRenderer.js